import * as React from "react";

import { createSvgIcon } from "@mui/material/utils";

const Achievement11Icon = createSvgIcon(
    <svg
        width="160"
        height="160"
        viewBox="0 0 160 160"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M76.6223 158.427L33.9378 135.097C19.1794 127.03 10 111.552 10 94.7326V6C10 2.68629 12.6863 0 16 0H43H79.5H116H143C146.314 0 149 2.6863 149 6V94.7326C149 111.552 139.821 127.03 125.062 135.097L82.3777 158.427C80.5844 159.407 78.4156 159.407 76.6223 158.427Z"
            fill="url(#paint0_linear_5305_1602)"
        />
        <g filter="url(#filter0_i_5305_1602)">
            <path
                d="M76.6129 141.415L48.8659 126.185C34.1476 118.106 25 102.65 25 85.8603V23C25 19.6863 27.6863 17 31 17H50.8777H79.5H108.122H128C131.314 17 134 19.6863 134 23V85.8603C134 102.65 124.852 118.106 110.134 126.185L82.3871 141.415C80.5889 142.402 78.4111 142.402 76.6129 141.415Z"
                fill="url(#paint1_linear_5305_1602)"
            />
        </g>
        <path
            d="M76.6129 141.415L48.8659 126.185C34.1476 118.106 25 102.65 25 85.8603V23C25 19.6863 27.6863 17 31 17H50.8777H79.5H108.122H128C131.314 17 134 19.6863 134 23V85.8603C134 102.65 124.852 118.106 110.134 126.185L82.3871 141.415C80.5889 142.402 78.4111 142.402 76.6129 141.415Z"
            stroke="#182370"
            strokeWidth="3"
        />
        <g filter="url(#filter1_d_5305_1602)">
            <path
                d="M78.2065 32.634C78.9402 31.1475 81.0598 31.1475 81.7935 32.634L85.4125 39.9669C85.7038 40.5572 86.267 40.9664 86.9184 41.061L95.0108 42.2369C96.6512 42.4753 97.3063 44.4912 96.1192 45.6483L90.2635 51.3562C89.7921 51.8157 89.577 52.4777 89.6883 53.1265L91.0707 61.1862C91.3509 62.82 89.636 64.066 88.1688 63.2946L80.9307 59.4893C80.348 59.183 79.652 59.183 79.0693 59.4893L71.8312 63.2946C70.364 64.066 68.6491 62.82 68.9293 61.1862L70.3117 53.1265C70.423 52.4777 70.2079 51.8157 69.7365 51.3562L63.8808 45.6483C62.6937 44.4912 63.3488 42.4753 64.9892 42.2369L73.0816 41.061C73.733 40.9664 74.2962 40.5572 74.5875 39.9669L78.2065 32.634Z"
                fill="url(#paint2_linear_5305_1602)"
            />
            <path
                d="M78.8789 32.9658C79.3088 32.0948 80.5004 32.0404 81.0254 32.8027L81.1211 32.9658L84.7402 40.2988C85.1158 41.0598 85.8198 41.6015 86.6445 41.7734L86.8105 41.8037L94.9033 42.9795C95.8642 43.1194 96.284 44.235 95.7217 44.9697L95.5957 45.1113L89.7402 50.8193C89.1326 51.4116 88.8346 52.2485 88.9258 53.0859L88.9492 53.2529L90.3311 61.3135C90.4949 62.2705 89.5639 63.0146 88.6914 62.707L88.5176 62.6309L81.2793 58.8252C80.5283 58.4305 79.6401 58.4055 78.8721 58.751L78.7207 58.8252L71.4824 62.6309C70.6226 63.0829 69.6269 62.4264 69.6504 61.501L69.6689 61.3135L71.0508 53.2529C71.1941 52.4165 70.9431 51.5642 70.377 50.9404L70.2598 50.8193L64.4043 45.1113C63.7088 44.4334 64.025 43.2834 64.9121 43.0195L65.0967 42.9795L73.1895 41.8037C74.0291 41.6817 74.7622 41.1792 75.1807 40.4482L75.2598 40.2988L78.8789 32.9658Z"
                stroke="#182370"
                strokeWidth="1.5"
            />
        </g>
        <g filter="url(#filter2_d_5305_1602)">
            <path
                d="M78.2065 72.634C78.9402 71.1475 81.0598 71.1475 81.7935 72.634L85.4125 79.9669C85.7038 80.5572 86.267 80.9664 86.9184 81.061L95.0108 82.2369C96.6512 82.4753 97.3063 84.4912 96.1192 85.6483L90.2635 91.3562C89.7921 91.8157 89.577 92.4777 89.6883 93.1265L91.0707 101.186C91.3509 102.82 89.636 104.066 88.1688 103.295L80.9307 99.4893C80.348 99.183 79.652 99.183 79.0693 99.4893L71.8312 103.295C70.364 104.066 68.6491 102.82 68.9293 101.186L70.3117 93.1265C70.423 92.4777 70.2079 91.8157 69.7365 91.3562L63.8808 85.6483C62.6937 84.4912 63.3488 82.4753 64.9892 82.2369L73.0816 81.061C73.733 80.9664 74.2962 80.5572 74.5875 79.9669L78.2065 72.634Z"
                fill="url(#paint3_linear_5305_1602)"
            />
            <path
                d="M78.8789 72.9658C79.3088 72.0948 80.5004 72.0404 81.0254 72.8027L81.1211 72.9658L84.7402 80.2988C85.1158 81.0598 85.8198 81.6015 86.6445 81.7734L86.8105 81.8037L94.9033 82.9795C95.8642 83.1194 96.284 84.235 95.7217 84.9697L95.5957 85.1113L89.7402 90.8193C89.1326 91.4116 88.8346 92.2485 88.9258 93.0859L88.9492 93.2529L90.3311 101.313C90.4949 102.27 89.5639 103.015 88.6914 102.707L88.5176 102.631L81.2793 98.8252C80.5283 98.4305 79.6401 98.4055 78.8721 98.751L78.7207 98.8252L71.4824 102.631C70.6226 103.083 69.6269 102.426 69.6504 101.501L69.6689 101.313L71.0508 93.2529C71.1941 92.4165 70.9431 91.5642 70.377 90.9404L70.2598 90.8193L64.4043 85.1113C63.7088 84.4334 64.025 83.2834 64.9121 83.0195L65.0967 82.9795L73.1895 81.8037C74.0291 81.6817 74.7622 81.1792 75.1807 80.4482L75.2598 80.2988L78.8789 72.9658Z"
                stroke="#182370"
                strokeWidth="1.5"
            />
        </g>
        <defs>
            <filter
                id="filter0_i_5305_1602"
                x="23.5"
                y="15.5"
                width="116"
                height="132.156"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="BackgroundImageFix"
                    result="shape"
                />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dx="4" dy="4" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite
                    in2="hardAlpha"
                    operator="arithmetic"
                    k2="-1"
                    k3="1"
                />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
                />
                <feBlend
                    mode="normal"
                    in2="shape"
                    result="effect1_innerShadow_5305_1602"
                />
            </filter>
            <filter
                id="filter1_d_5305_1602"
                x="58.2747"
                y="25.5191"
                width="45.4507"
                height="44.0096"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dx="1" />
                <feGaussianBlur stdDeviation="3" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_5305_1602"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_5305_1602"
                    result="shape"
                />
            </filter>
            <filter
                id="filter2_d_5305_1602"
                x="58.2747"
                y="65.5191"
                width="45.4507"
                height="44.0096"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dx="1" />
                <feGaussianBlur stdDeviation="3" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_5305_1602"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_5305_1602"
                    result="shape"
                />
            </filter>
            <linearGradient
                id="paint0_linear_5305_1602"
                x1="10"
                y1="0"
                x2="168.978"
                y2="141.565"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#586EC3" />
                <stop offset="1" stopColor="#0C1779" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_5305_1602"
                x1="25"
                y1="17"
                x2="149.688"
                y2="124.865"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#2E4898" />
                <stop offset="1" stopColor="#122181" />
            </linearGradient>
            <linearGradient
                id="paint2_linear_5305_1602"
                x1="109.091"
                y1="69"
                x2="69.2857"
                y2="15.3625"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#4E64D5" />
                <stop offset="1" stopColor="#8199E6" />
            </linearGradient>
            <linearGradient
                id="paint3_linear_5305_1602"
                x1="109.091"
                y1="109"
                x2="69.2857"
                y2="55.3625"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#4E64D5" />
                <stop offset="1" stopColor="#8199E6" />
            </linearGradient>
        </defs>
    </svg>,
    "Achievement11Icon",
);

export default Achievement11Icon;
